import PressDNSDescription from "../../../../src/courses/partials/services/pressdns.mdx";
import * as React from 'react';
export default {
  PressDNSDescription,
  React
};